import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'isArray'})
export class IsArrayPipe implements PipeTransform {
  transform(subject: unknown | unknown[]): boolean {
    return Array.isArray(subject);
  }
}
